import React from 'react';
import classNames from "classnames";
import './index.scss';

const BubbleListContent = (props: any) => {
  const { title, list, className, ...rest } = props;
  return (<div className={classNames('dbl-bubble-list-content', className)} {...rest}>
    <div className={'dbl-bubble-list-content__title'}>{title}</div>
    <div className={'dbl-bubble-list-content__list'}>
      {
        list?.map((item: any, index: number) => (<div className={'item'} key={index}>
          {item}
        </div>))
      }
    </div>
  </div>);
};


export default BubbleListContent;